import React, { FC } from 'react'
import { useIntl } from 'react-intl'
interface IProps {
  margin: any
  paymentType: string
}
const ContractMarginTable:FC<IProps> = ({margin,paymentType}) => {
  const {formatMessage} = useIntl();
  const isTrade = ()=> paymentType.toLowerCase() == 'trade'
  
  return (
    <div className='col-sm-12'>
      <label className='text-gray-600 fw-bold fs-5 d-block mb-5'>{formatMessage({ id: "A_label" })}) {isTrade() ? formatMessage({ id: "rebate_lbl" }): formatMessage({ id: "margin_lbl" })}</label>
      <div className='border-bottom row pb-1'>
        <div className='row'>
          <div className='col-md-6'>
            <label className='text-gray-600 fw-bold fs-5 px-sm-4'>{isTrade() ? formatMessage({ id: "fixed_rebate" }) : formatMessage({ id: "fixed_margin" })}</label>
          </div>
          <div className='col-md-6'>
            <p className='text-dark fs-4 mb-0 fw-bold'>{margin}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContractMarginTable
